<div class="content-list">
  <dcu-box-data *ngIf="bodyContent">
    <div title class="header-custom">
      <dcu-body-header *ngIf="bodyContent.header" [headerTitle]="bodyContent.header?.title" [subTitle]="bodyContent.header?.subTitle"></dcu-body-header>

      <div class="status-select"></div>

      <div class="btn-group btn-group-toggle float-right" *ngIf="bodyContent.searchArea">
        <dcu-input-search
          *ngIf="bodyContent.searchArea?.box"
          (doSearch)="onChangeSearch($event)"
          [placeholder]="bodyContent.searchArea.placeholder ? bodyContent.searchArea.placeholder : 'Search for records'"
        >
        </dcu-input-search>
        <i class="fa fa-filter" aria-hidden="true" *ngIf="bodyContent.searchArea?.filter" (click)="toggleFilter()" id="{{id}}-filter-icon"></i>
        <button type="button" class="close" (click)="addNewCustom()" *ngIf="bodyContent.closeDialog">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <dcu-body-filter
      [hidden]="!showFilter"
      [filterData]="bodyContent.filterConfig"
      (onChangeSearch)="onChangeFilter($event)"
      (onChangeForm)="onChangeDataFilter($event)"
      (keyup.enter)="onChangeFilter($event)"
      [idFilter]="id"
      [classCustom]="bodyContent.classCustom"
      (clearValue)="onClearValue($event)"
      [isCustomCancelFilter]="isCustomCancelFilter"
      [triggerBtnName]="bodyContent.triggerBtnName"
    ></dcu-body-filter>

    <ng-content select="[retrieve]"></ng-content>
    <div class="action-bar" *ngIf="bodyContent.subActionBars">
      <div *ngIf="bodyContent.subHeader" class="sub-header">{{bodyContent.subHeader}}</div>
      <dcu-action-bar class="editStyle"
                        [actionBarConfig]="bodyContent.subActionBars"
                        [selectedRecords]="selectedRecords"
                        (deletingCompleted)="refreshList()"
                        (refreshChange)="refreshList()"
                        [screenName]="bodyContent.subActionBars?.screenName ? bodyContent.subActionBars.screenName : 'companyCustomAttribute'"
                        [actionId]="bodyContent.subActionBars.id ? bodyContent.subActionBars.id : 'sub-action-id'"
                        [valueParent]="bodyContent.valueParent"
                        [isEditStatusDate]="isEditDateDeactivate"
                        [dataFilter]="dataFilter"
                        (addNewCustom)="addNewCustom()"
      >
      </dcu-action-bar>
    </div>
    <dcu-table-common #tbl
                        [tableConfig]="bodyContent.tableConfig"
                        (selectedValueChange)="onSelectedRow($event)"
                        (rowSelectedChange)="onClickRow($event)"
                        [refresh]="refresh"
                        [idTable]="id">
    </dcu-table-common>
  </dcu-box-data>
</div>
